<template>
  <Modal v-model="show"
         width="80"
         class="kfzmodal">
    <p slot="header"></p>
    <div style="padding: 0 0 15px;">
      <img src="../../static/img/kfz.jpg" style="display: block; margin: 0 auto;" alt="">
    </div>
    <div slot="footer"></div>
  </Modal>
</template>

<script type="text/ecmascript-6">
  export default {
    name: 'kfz',
    props: {
      show:{
        type:Boolean,
        default:false
      }
    },
    data() {
      return {

      }
    },
    watch: {

    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style lang="scss">
  /*@import "../../../static/css/template/header";*/
  .kfzmodal{
    .ivu-modal-body{
      padding-top: 50px;
    }
    .ivu-modal-header,.ivu-modal-footer{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/kfz/kfz.vue